import { createContext, useContext } from 'react';
import { ScopeContextProps } from './types';

export const ScopeContext = createContext<undefined | string>(undefined);

export default ({ value, children }: ScopeContextProps) => (
    <ScopeContext.Provider value={value}>{children}</ScopeContext.Provider>
);

export const useScope = () => useContext(ScopeContext);
